import { render, staticRenderFns } from "./DocManagmentUploadFile.vue?vue&type=template&id=b10f4bb8&"
import script from "./DocManagmentUploadFile.vue?vue&type=script&lang=js&"
export * from "./DocManagmentUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10f4bb8')) {
      api.createRecord('b10f4bb8', component.options)
    } else {
      api.reload('b10f4bb8', component.options)
    }
    module.hot.accept("./DocManagmentUploadFile.vue?vue&type=template&id=b10f4bb8&", function () {
      api.rerender('b10f4bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/DocManagmentUploadFile.vue"
export default component.exports